<h1 class="Anton">Contacto</h1>
<div class="container">
    <div class="row">
        <div class="col">
            <div>
                <span class=h5>Email: </span><span>steventaday8@hotmail.com</span>
            </div>
            <div>
                <span class=h5>Telefono: </span><span>0985562141</span>
            </div>
            <div>
                <span class=h5>Facebook: </span><a href="https://www.facebook.com/Brayan.Taday.98">@Brayan.Taday.98</a>
            </div>
            <div>
                <span class=h5>Instagram: </span><a href="https://www.instagram.com/Brayan___Taday/">@brayan___taday</a>
            </div>
            <div>
                <span class=h5>Twitter: </span><a href="https://twitter.com/Brayan___Taday">@Brayan___Taday</a>
            </div>
        </div>
        <div class="col">
            <img src="assets/images/Brayan.jpg" alt="">
        </div>
    </div>


</div>